import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  startDate: {
    id: 'generic.course-card.start-date',
    defaultMessage: 'Starts: {startDate}',
    description: 'Start date.',
  },
});

export default messages;
